import { api } from '@/lib/api';
import type { IApiResponse, IOrgHierarchy } from '@skystone/shared';

export const orgHierarchyApi = {
  getAll: async (includeArchived = false): Promise<IOrgHierarchy> => {
    const params = includeArchived ? '?includeArchived=true' : '';
    const result = await api.get<IApiResponse<IOrgHierarchy>>(`/org-hierarchy${params}`);
    return result.data;
  },
};
